import React from "react";
import "./property-info.styles.scss";

const PropertyInfo = ({ handleToggle }) => {
  return (
    <div className="tour-information">
      <div className="tour-information-card">
        <div className="card-header">
          <button onClick={() => handleToggle(false)}>close</button>
        </div>
        <div className="card-texts">
          <div className="card-category">
            <h2>Property Details (DEMO ONLY)</h2>
            <span className="card-subheader">Property Name</span>
            <span>The Beninngton</span>
            <div className="divider-line"></div>
            <span className="card-subheader">Address</span>
            <span>10,Jalan Utama 23/45e</span>
            <div className="divider-line"></div>
            <span className="card-subheader">Property units</span>
            <span>350 units</span>
            <div className="divider-line"></div>
            <span className="card-subheader">Developer</span>
            <span>PropertyBuilder Sdn Bhd</span>
            <div className="divider-line"></div>
            <span className="card-subheader">Project Type</span>
            <span>Serviced-Apartment</span>
            <div className="divider-line"></div>
            <span className="card-subheader">Completion Year</span>
            <span>2019</span>
            <div className="divider-line"></div>
          </div>
          <div className="card-category">
            <h2>Unit Features</h2>
            <span>2+2 bedrooms</span>
            <div className="divider-line"></div>
            <span>1200 sq.ft.</span>
            <div className="divider-line"></div>
            <span>Semi-Furnished</span>
            <div className="divider-line"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyInfo;
